import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import CAMPAIGN from "@/data/campaign";

const ParallaxBreak = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-18%", "18%"]);
  const p = CAMPAIGN.parallax;

  return (
    <section ref={ref} className="relative h-[55vh] md:h-[70vh] overflow-hidden" data-testid="parallax-break">
      <motion.img
        src={p.image}
        alt={p.imageAlt}
        className="absolute inset-0 w-full h-[140%] object-cover -top-[20%]"
        style={{ y }}
      />
      <div className="absolute inset-0 bg-[#12251d]/45" />
      <div className="relative z-10 h-full flex items-center justify-center px-6">
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
          className="font-heading italic font-light text-3xl sm:text-4xl md:text-6xl text-[#F5F2EB] text-center max-w-4xl leading-tight"
          data-testid="parallax-quote"
        >
          "{p.quote1}<br className="hidden sm:block" /> {p.quote2}"
        </motion.p>
      </div>
    </section>
  );
};

export default ParallaxBreak;
